class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

    if (isCombinedProduct) {
      this.fetchProductSection(targetUrl);
      return;
    }

    this.updateOptions();
    this.updateMasterId();

    // Set button immediately based on selected variant availability
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(
        !this.currentVariant.available,
        this.currentVariant.available
          ? ''
          : window.variantStrings.soldOut,
      );
    }

    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (this.currentVariant) {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  combinedListingCheck(e) {
    const currentUrl = window.location.pathname;
    const targetUrl = e.target.dataset.productUrl;
    let isCombinedProduct = false;

    if (targetUrl != undefined && currentUrl != targetUrl) {
      isCombinedProduct = true;
    }

    return { isCombinedProduct, targetUrl };
  }

  async fetchProductSection(newProductUrl) {
    const productElement = this.closest('.main-product');
    const productSectionId = this.dataset.section;
    let params = `section_id=${productSectionId}&`;

    const selectedOptionValues = Array.from(
      this.querySelectorAll('fieldset input:checked'),
    )
      .map((element) => element.dataset.optionValueId)
      .join(',');
    params += `option_values=${selectedOptionValues}`;

    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        productElement.innerHTML =
          html.querySelector('.main-product').innerHTML;
        window.history.replaceState({}, '', `${newProductUrl}`);
      });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(
      `slider-${this.dataset.section}`,
    );
    const thumbnailsGridySlider = document.getElementById(
      `thumbnail-slider-${this.dataset.section}`,
    );

    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`,
      );
    }

    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(
        `thumbnail-item-${this.currentVariant.featured_media.id}`,
      );
    }

    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    const isGrid =
      mediaGridySlider.dataset.desktopEnabled === 'false' ? true : false;
    if (isDesktop && isGrid) {
      document
        .getElementById(`item-${this.currentVariant.featured_media.id}`)
        ?.scrollIntoView();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const rawValue = input.getAttribute('value');
      const translatedValue =
        input.dataset.variantValueTranslated || rawValue;

      if (listOfAvailableOptions.includes(rawValue)) {
        input.innerText = translatedValue;
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          translatedValue
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector(
      '[data-product-inventory]',
    );

    if (
      !this.productInventoryNode ||
      !window.inventories ||
      !window.inventories[this.dataset.productId]
    )
      return;

    this.inventoryThreshold = parseInt(
      this.productInventoryNode.dataset.threshold,
    );
    this.showQuantityInStock =
      this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject =
      window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (
        variantInventoryObject.quantity <= 0 &&
        variantInventoryObject.incoming === 'true' &&
        variantInventoryObject.quantity < this.inventoryThreshold
      ) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(
          true,
          variantInventoryObject.next_incoming_date,
        );
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    this.productInventoryNode.classList.remove(
      'inventory-status--in-stock',
      'inventory-status--low',
      'inventory-status--sold-out',
      'inventory-status--sold-out-continue-selling',
    );

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) <= parseInt(this.inventoryThreshold) &&
      parseInt(quantity) > 0
    ) {
      this.productInventoryNode.classList.add('inventory-status--low');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left_with_quantity.replace(
            '[quantity]',
            quantity,
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) > parseInt(this.inventoryThreshold)
    ) {
      this.productInventoryNode.classList.add('inventory-status--in-stock');
      if (this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock_with_quantity.replace(
            '[quantity]',
            quantity,
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) < 1
    ) {
      this.productInventoryNode.classList.add(
        'inventory-status--sold-out-continue-selling',
      );
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove('hide');
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector(
      '[data-incoming-inventory]',
    );
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date
      ? window.variantStrings.inventory.waiting_for_stock
      : window.variantStrings.inventory.will_be_in_stock_after.replace(
          '[date]',
          date,
        );

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const buyBarInfoSource = html.getElementById(
          `buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo)
          destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            'hidden',
            skuSource.classList.contains('hidden'),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll(
      '.btn--add-multiplier',
    );
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach((button) => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach((button) => {
          button.removeAttribute('disabled');
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`,
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span',
      );

      if (disable) {
        addButton_BuyBar.setAttribute('disabled', 'disabled');
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute('disabled');
        if (this.dataset.isPreorder == 'true') {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`,
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span',
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`,
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value;
    });
    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      if (!legend) return;

      const selectedOption = Array.from(
        fieldset.querySelectorAll('input'),
      ).find((radio) => radio.checked);

      if (!selectedOption) return;

      legend.textContent =
        selectedOption.dataset.variantValueTranslated ||
        selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantRemoteSelect extends VariantSelects {
  constructor() {
    super();
    this.syncing = false;
    this.variantRadios = document.querySelector('variant-radios');

    if (!this.variantRadios) {
      // no synchronization needed
      return;
    }
  }

  connectedCallback() {
    this.selects = Array.from(this.querySelectorAll('select'));
    this.selects.forEach(select =>
      select.addEventListener('change', this.handleRemoteSelectChange.bind(this))
    );

    if (this.variantRadios) {
      this.variantRadios.addEventListener('change', this.onVariantChangeReverse.bind(this));
    }
  }

  handleRemoteSelectChange(event) {
    if (this.syncing) return;
    this.syncing = true;

    const val = event.target.value;
    const radio = document.querySelector(`input[type="radio"][value="${val}"]`);
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    super.onVariantChange(event);
    this.syncing = false;
  }

  onVariantChangeReverse(event) {
    if (this.syncing) return;
    this.syncing = true;

    const val = event.target.value;
    const select = this.selects.find(s =>
      Array.from(s.options).some(opt => opt.value === val)
    );

    if (select) {
      select.value = val;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    super.onVariantChange?.(event);
    this.syncing = false;
  }
}

customElements.define('variant-selects-remote', VariantRemoteSelect);

class ProductBuyBar extends HTMLElement {
  constructor() {
    'use strict';
    super();

    let classes = { show: 'show' };
    let mainProductForm = document.querySelector('.product-form');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 },
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener('DOMContentLoaded', function () {
      let siteFooter = document.querySelector('footer.footer');
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define('product-buy-bar', ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) {
          this.updateImage(newImgSrc);
        }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

// GROUPING ELEMENT
class VariantItems extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  async init() {
    this.cartItemsJSON = JSON.parse(
      this.querySelector('.ajax-cart').innerHTML,
    )?.items;
    this.addEventListener(
      'variantItemQuantityChange',
      this.updateCart.bind(this),
    );
  }

  setLoadingState(isLoading, silently = false) {
    this.isLoading = isLoading;
    this.setAttribute('data-is-loading', isLoading);
    if (silently === false) {
      this.classList.toggle('is-loading', isLoading);
    }
  }

  async fetchLiveProduct(variantId) {
    /**
     * Build URL for displaying selected variant
     * window.routes.root = '/' or '/en/'
     * @type {URL}
     * @example https://www.example.com/products/product-handle?variant=456
     */

    const url = new URL(
      window.top.location.origin +
        window.routes.root +
        '/products/' +
        this.dataset.productHandle,
    );
    url.searchParams.set('variant', variantId);
    url.searchParams.set('view', 'ajax-variant-items');

    // Fetch fresh HTML for the product
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/html',
      },
    });
    const html = await response.text();

    // Parse the HTML into a DOM
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    return doc;
  }

  /**
   * Update the cart
   * - Add or update the current variant
   *
   */
  async updateCart(event) {
    this.setLoadingState(true, true);
    const { variantId, quantity } = event.detail;

    const updateMethod =
      this.cartItemsJSON &&
      this.cartItemsJSON.find((item) => item.variant_id === variantId)
        ? 'update'
        : 'add';
    console.log('update cart', updateMethod, variantId, quantity);

    if (updateMethod === 'add' && quantity === 0) {
      return;
    }

    try {
      const response = await this.updateCartPromise(
        updateMethod,
        variantId,
        quantity,
      );
      const json = await response.json();

      if (!response.ok) throw new Error(json.description);

      // now find the freshly added item in the cart
      // and add it to the cartItemsJSON array
      if (updateMethod === 'add') {
        // if updateMethod is 'add'
        // then the item is the last item in the cart
        const the_item = json.items[json.items.length - 1];
        if (!this.cartItemsJSON) this.cartItemsJSON = [];
        this.cartItemsJSON.push(the_item);
      } else {
        // if updateMethod is 'update'
        // find the item in the cartItemsJSON array
        // and update the quantity
        if (quantity === 0) {
          // remove item from cartItemsJSON
          this.cartItemsJSON = this.cartItemsJSON.filter(
            (item) => item.variant_id !== variantId,
          );
        } else {
          const thisCartItem = this.cartItemsJSON.find(
            (item) => item.variant_id === variantId,
          );
          thisCartItem.quantity = quantity;
        }
      }

      // trigger custom event 'ajaxProduct:added' to update cart drawer
      this.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            silently: true,
          },
        }),
      );
      // update notification bar
      const doc = await this.fetchLiveProduct();
      const notificationBar = doc.querySelector(
        '.ajax-notification .cart_item--notification',
      );
      const _notificationBar = this.querySelector(
        '.ajax-notification .cart_item--notification',
      );
      const thisProductInCart = this.cartItemsJSON.find(
        (item) => item.handle === this.dataset.productHandle,
      );

      if (updateMethod === 'add') {
        _notificationBar.classList.add('show');
        _notificationBar.innerHTML = notificationBar.innerHTML;
      } else if (
        updateMethod === 'update' &&
        quantity === 0 &&
        !thisProductInCart
      ) {
        _notificationBar.classList.remove('show');
        _notificationBar.innerHTML = '';
      } else {
        _notificationBar.innerHTML = notificationBar.innerHTML;
      }
      // Update total value after notification bar content is replaced
      this.updateTotalValue();
    } catch (error) {
      alert(error);
      console.error(error);
    }

    this.setLoadingState(false, true);
  }

  updateTotalValue() {
    let totalValue = 0;

    // Calculate total value for this product
    this.cartItemsJSON.forEach((item) => {
      if (item.handle === this.dataset.productHandle) {
        totalValue += (item.quantity * item.final_price) / 100; // Convert price from cents to dollars
      }
    });

    // Update the total value in the DOM
    const totalValueElement = this.querySelector('#product-total-value');
    const currency = totalValueElement?.dataset.currency;
    if (totalValueElement) {
      totalValueElement.textContent = totalValue.toLocaleString('en-US', {
        style: 'currency',
        currency: currency, // Adjust currency if needed
      });
    }
  }

  async updateCartPromise(updateMethod, variantId, quantity) {
    if (updateMethod === 'add' && quantity === 0) {
      // return empty json
      return new Promise((resolve, reject) => {
        resolve({
          json: () => {
            return {
              items: [],
            };
          },
        });
      });
    } else if (updateMethod === 'update') {
      // remove item from cart
      return new Promise(async (resolve, reject) => {
        const thisCartItem = this.cartItemsJSON.find(
          (item) => item.variant_id === variantId,
        );
        const line_key = thisCartItem.key;

        const response = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: line_key,
            quantity: quantity,
          }),
        });
        resolve(response);
      });
    } else if (updateMethod === 'add' && quantity > 0) {
      // add item to cart
      return new Promise(async (resolve, reject) => {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: quantity,
              },
            ],
          }),
        });
        resolve(response);
      });
    }
  }
}
customElements.define('variant-items', VariantItems);

// SINGLE VARIANT ITEM
class VariantItem extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  async init() {
    this.initQuantityInputs();
  }

  initQuantityInputs() {
    this.quantityRules = JSON.parse(
      this.querySelector('[data-increment]').dataset.increment,
    );

    // Initialize quantity change event.
    this.quantityInputs = this.querySelectorAll('input[type=number]');
    this.quantityInputs.forEach((input) => {
      input.addEventListener('change', this.changeQuantity.bind(this));
    });

    // Initialize quantity buttons
    this.quantityButtons = this.querySelectorAll('.quantity__button');
    this.quantityButtons.forEach((button) => {
      button.addEventListener('click', this.changeQuantity.bind(this));
    });
  }

  changeQuantity(event) {
    // Identify if called by click or change event
    const isClick = event.type === 'click';
    const quantityInput = this.querySelector('input[type=number]');

    // If click, and button name is "minus" then decrease quantity
    if (isClick && event.target.name === 'minus') {
      // Click - minus button
      quantityInput.value =
        parseInt(quantityInput.value) - this.quantityRules.increment;
    } else if (isClick && event.target.name === 'plus') {
      // Click - plus button
      quantityInput.value =
        parseInt(quantityInput.value) + this.quantityRules.increment;
    } else {
      // Change - input field
      // round the input value to closest increment value if not already
      const roundedValue =
        Math.round(event.target.value / this.quantityRules.increment) *
        this.quantityRules.increment;
      quantityInput.value = roundedValue;

      // Don't round to zero, unless the user has manually entered zero
      if (
        parseInt(quantityInput.value) === 0 &&
        parseInt(event.target.value) > 0
      ) {
        quantityInput.value = this.quantityRules.increment;
      }
    }

    // Make sure quantity is not less than 0
    if (parseInt(quantityInput.value) < 0) {
      quantityInput.value = 0;
    }

    // Make sure quantity is not over the max quantity. Null means no max quantity
    if (
      this.quantityRules.max &&
      parseInt(quantityInput.value) > this.quantityRules.max
    ) {
      quantityInput.value = this.quantityRules.max;
    }

    // Make sure debounce is not called multiple times in a row
    if (this.waitingForPreviousDebounce) {
      return;
    }

    // Update the cart, with "debounce" function
    const debouncedUpdate = (func, wait) => {
      let timeout;
      return function executedFunction() {
        const later = () => {
          timeout = null;
          func();
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    this.waitingForPreviousDebounce = true;
    const debounceDelay = isClick ? 750 : 350;

    // fire "variantItemQuantityChange" event
    debouncedUpdate(() => {
      this.dispatchEvent(
        new CustomEvent('variantItemQuantityChange', {
          bubbles: true,
          detail: {
            variantId: parseInt(this.dataset.variantId),
            quantity: parseInt(this.querySelector('input[type=number]').value),
          },
        }),
      );
      this.waitingForPreviousDebounce = false;
    }, debounceDelay)();
  }
}
customElements.define('variant-item', VariantItem);

const Photoswipe = {
  attempts: 0,

  selectors: {
    images: '.photoswipe__image',
  },

  init: function () {
    document.querySelectorAll('.photoswipe__image').forEach((trigger) => {
      trigger.addEventListener('click', this.downloadAndMount.bind(this));
    });
  },

  downloadAndMount: function (evt) {
    if (this.attempts >= 10) {
      return;
    }
    this.attempts++;
    const existingScript = document.querySelector(
      `script[src="${theme.assets.photoswipe}"]`,
    );

    // If we are already processing one slider, wait a while and try again.
    if (window.processingPhotoswipe) {
      setTimeout(this.downloadAndMount.bind(this), 200);
      return;
    }

    // Photoswipe script was already found in document, proceed to immediately mount slider
    if (existingScript) {
      this.showZoom(evt);
      return;
    }

    // Photoswipe script was not found in document, download it and wait for it to load, then show zoom
    window.processingPhotoswipe = true;

    const script = document.createElement('script');
    script.setAttribute('defer', 'true');
    script.setAttribute('async', 'true');
    script.src = theme.assets.photoswipe;
    document.body.append(script);

    script.addEventListener('load', () => {
      this.showZoom(evt);
    });
  },

  showZoom: function (evt) {
    const target = evt.currentTarget || evt.target;
    this.targetElement = target.closest('[data-photoswipe-parent]');
    this.items = this.getImageData();

    this.initGallery(this.items, target.dataset.index || 1);
    window.processingPhotoswipe = false;
  },

  getImageData: function () {
    this.images = this.targetElement.querySelectorAll(this.selectors.images);

    const items = [];

    this.images.forEach((el) => {
      const item = {
        src: el.getAttribute('data-photoswipe-src'),
        w: parseInt(el.getAttribute('data-photoswipe-width')),
        h: parseInt(el.getAttribute('data-photoswipe-height')),
        initialZoomLevel: 0.5,
      };

      items.push(item);
    });

    return items;
  },

  initGallery: function (items, index) {
    const pswpElement = document.querySelectorAll('.pswp')[0];

    const options = {
      allowPanToNext: false,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: parseInt(index) - 1,
      pinchToClose: false,
      preloaderEl: false,
      shareEl: false,
      tapToToggleControls: false,
    };

    this.gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options,
    );
    this.gallery.init();
  },
};
Photoswipe.init();
